import { toast } from 'react-hot-toast';
import { format } from 'react-string-format';

export const ToastCreateSuccessBottomLeft = (pageName: string) => {
    const message = format('عملیات ثبت {0} با موفقیت انجام گردید', pageName);
    toast.success(message)
}

export const ToastUpdateSuccessBottomLeft = (pageName: string) => {
    const message = format('عملیات ویرایش {0} با موفقیت انجام گردید', pageName);
    toast.success(message)
}

export const ToastDeleteSuccessBottomLeft = (pageName: string) => {
    const message = format('عملیات حذف {0} با موفقیت انجام گردید', pageName);
    toast.success(message)
}
export const ToastSuccessBottomLeft = (message: string) => {
    toast.success(message)
}

export const ToastErrorBottomLeft = (message: string) => {
    toast.error(message)
}

 export  const ToastsErrorTopCenter = (message: string) => {
        toast.error(message, {
            position: 'top-center',
        });
    };

export const ToastsErrorBottomLeft = (messages: string[]) => {
    messages.map((message) => {
        toast.error(message)
    });
}

export const ToastPaternSuccessBottomLeft = (pageName: string) => {
    const message = format('عملیات {0} با موفقیت انجام گردید', pageName);
    toast.success(message)
}
